import React, { useEffect, useState, useRef } from 'react'
import SockJS from "sockjs-client";
import { Client } from '@stomp/stompjs';
import BootstrapTable from 'react-bootstrap-table-next';
import Lib from "../../../commons/lib";
import { useParams } from 'react-router-dom';
import Services from './Services';
import SvgViewer from '../../../commons/SvgViewer';
import Page404 from '../../Pages/Page404';
import TimeFormatter from '../../../commons/TimeFormatter';
import NumberFormatter from '../../../commons/NumberFormatter';

let sockjs = null;

const KulsokliensContent = (props) => {

  const [ clientType, setClientType ] = useState('REKLAM');
  const [ layout, setLayout ] = useState({
    vna: null,
    hna: null
  });
  const [ event, setEvent ] = useState({ nam: null });
  const [ init, setInit ] = useState({ sectors: null });
  const [ sessionId, setSessionId ] = useState(null);
  const [ connected, setConnected ] = useState(false);
  const [ error, setError ] = useState(false);
  const [ areaTickets, setAreaTickets ] = useState([]);
  const [ seatTickets, setSeatTickets ] = useState([]);
  const [ areaIds, setAreaIds ] = useState([]);
  const [ seatIds, setSeatIds ] = useState([]);
  const { eszkozazonosito } = useParams();
  const logoRef = useRef(null);
  const [ logoImageString, setLogoImageString ] = useState(undefined);

  useEffect(() => {
    window.addEventListener("beforeunload", (e) => deleteSession(e), false);
    window.addEventListener("popstate", (e) => deleteSession(e), false);
    setCSS();
    renderToken();

    return () => {
      //ki commenteztem mert folyamatos hibát dobott mivel az interval nincs definiálva
      //clearInterval(interval);
      removeCSS();
    }
  }, []);


  // A setCSS változtatásait vissza kell vonni a removeCSS-ben
  const setCSS = () => {
    document.body.classList.add('kulsomonitor');
    setLogoColor();
  }

  const removeCSS = () => {
    document.body.classList.remove('kulsomonitor');
    removeLogoColor;
  }

  const setLogoColor = () => {
    if(getCorrectTextColor(getCssVarHexWithoutHash("--svg-viewer-hatter-szin")) === "#ffffff"){
      if(logoRef.current){
        logoRef.current.classList.add("feher-logo");
        logoRef.current.classList.remove('fekete-logo');
      }
    }else{
      if(logoRef.current){
        logoRef.current.classList.add("fekete-logo");
        logoRef.current.classList.remove('feher-logo');
      }
    }
  }

  const removeLogoColor = () => {
    if(logoRef.current){
      logoRef.current.classList.remove('fekete-logo');
      logoRef.current.classList.remove('feher-logo');
    }
  }

  const deleteSession = (e) => {
    if(sockjs) {
      Services.deleteSession(sessionId, (err, res) => {
        if (!err) {
        }
      });
    }
  }

  const msConversion = (millis) => {
    let sec = Math.floor(millis / 1000);
    let hrs = Math.floor(sec / 3600);
    sec -= hrs * 3600;
    let min = Math.floor(sec / 60);
    sec -= min * 60;
    sec = '' + sec;
    sec = ('00' + sec).substring(sec.length);
  
    if (hrs > 0) {
      min = '' + min;
      min = ('00' + min).substring(min.length);
      return min;
    }
    else {
      return min;
    }
  }

  const emptyFormatter = (data) => {
    if(!data || data === '') return '-';
    return data;
  }

  const isSeatSelected = (seatid, seats) => {
    let hasItem = false;

    seats.forEach(seat => {
      if(seat.sid === seatid) hasItem = true;
    });

    return hasItem;
  }

  const refreshToken = (interval) => {
    if(props.globals.keycloak.updateToken) {
      interval = setInterval(() => props.globals.keycloak.updateToken(msConversion(interval)), 1000);
    }
  }

  const renderToken = () => {
   
    Services.getTimeoutMs((err, res) => {
      if (!err) {
        const updateTime = res[0] - 10000;
        refreshToken(updateTime);
        if(!connected) {
            let clientId = Lib.MicroServices.keycloak.clientId;
            let token = Lib.MicroServices.keycloak.token;

            const randomString = (length=10)=>Math.random().toString(20).substr(2, length);
            const sessionId = randomString();

            const client = new Client();
            sockjs = new SockJS(window.location.origin + "/api/helyszin/ws?eszkozazonosito=" + eszkozazonosito + "&wsclientid=" + clientId + "&wstoken=" + token,[], {
              sessionId: () => {
                 return sessionId;
              }});

            client.webSocketFactory = function () {
                return sockjs;
            };
            client.configure({
              onConnect: () => {
                setConnected(true);
                setSessionId(sessionId);
                setError(false);
                client.subscribe('/user/'+sessionId+'/kulsomonitor', message => {
                  const payload = JSON.parse(message.body).payload;
                  const bean = payload.getbean;
                  const rendeles = payload.rendeles;
                  setColorsFromId(bean?.layout?.vid);
                  switch (payload.type) {
                    case 'LEKERDEZES':
                      setAreaTickets([]);
                      setSeatTickets([]);
                      setAreaIds([]);
                      setSeatIds([]);
                      setClientType(payload.type);
                      setLayout(payload.layout);
                      setEvent(payload.event);
                      setInit(payload.init);
                      break;
                    case 'FOGLALAS':
                      setAreaTickets([]);
                      setSeatTickets([]);
                      setAreaIds([]);
                      setSeatIds([]);
                      let seats = [];
                      let updatedBlocks = bean?.layout?.blocks?.map((block) => {
                        block.seats.forEach((seat) => {
                          if(isSeatSelected(seat.tid, rendeles.seattickets)) {
                              seat.new = true;
                              seats.push({
                                block: { lab: block.lab, lsp: block.lsp, lss: block.lss, lbp: block.lbp },
                                seat: { tid: seat.tid, lab: seat.lab, sec: seat.sec }
                              });
                          }
                        })
                        return block;
                      })

                      let updatedAreas = bean?.layout?.areas?.map((area) => {
                        if (rendeles.areatickets.find(x => x.aid === area.tid)) {
                          area.new = true;
                        }

                        return area;
                      })

                      let updatedLayout = bean.layout;
                      updatedLayout.blocks = updatedBlocks;
                      updatedLayout.areas = updatedAreas;

                      setClientType(payload.type);
                      setLayout(updatedLayout);
                      setEvent(bean.event);
                      setInit(bean.init);

                      createAreaTicketsObj(bean.layout.areas, bean.tickets, rendeles.areatickets);
                      createSeatTicketsObj(seats, bean.tickets, rendeles.seattickets, bean.init.sectors);
                      break;
                    case 'REKLAM':
                      setAreaTickets([]);
                      setSeatTickets([]);
                      setAreaIds([]);
                      setSeatIds([]);
                      setClientType(payload.type);
                      break;
                    default:
                      break;
                  }
                });
              },
            });
            client.activate();
         }
       }
      });

    return '';
  }

  const setColorsFromId = (id) => {
    if(!id) return;

    Services.getSzin(id, (errEvent, resEvent) => {
      if (!errEvent) {
        if (!isEmptyObject(resEvent[0])) {

          if (resEvent[0].color[0] === 'VILAGOS') {
            document.documentElement.style.setProperty("--svg-viewer-hatter-szin", "#fff");
            document.documentElement.style.setProperty("--base-font-szin", "#000")


            document.documentElement.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
            document.documentElement.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
            document.documentElement.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
            document.documentElement.style.setProperty("--form-control-focus-szin", hexToRgb(resEvent[0].color[2],80));




            document.documentElement.style.setProperty("--navbar-background", hexToRgb(resEvent[0].color[3],80));
          } else {
            document.body.classList.add('dark-theme');
            document.documentElement.style.setProperty("--svg-viewer-hatter-szin", "rgb(31,20,58)");

            document.body.style.setProperty("--base-font-szin", "#fff");
            document.body.style.setProperty("--elsodleges-szin", "#" + resEvent[0].color[1]);
            document.body.style.setProperty("--footer-hatter", "#" + resEvent[0].color[4]);
            document.body.style.setProperty("--input-border-focus-szin", "#" + resEvent[0].color[2])
            document.body.style.setProperty("--form-control-focus-szin", hexToRgb(resEvent[0].color[2],80));

            document.body.style.setProperty("--navbar-background", hexToRgb(resEvent[0].color[3],80));
          }

          if(resEvent[0].logo[0]){
            setLogoImageString("data:image/png;base64," + resEvent[0].logo[0])
          }else{
            setLogoImageString(undefined)
          }

          document.body.style.setProperty("--visszaszamlalo-szin", getCorrectTextColor(resEvent[0].color[1]))

          if (getContrastYIQ(resEvent[0].color[4]) === 'darkf') {
            document.body.style.setProperty("--footer-link-color", "#3c3c3c");
          } else {
            document.body.style.setProperty("--footer-link-color", "#dcdcdc");
          }

        }

      } else {
        //console.log('hiba')
      }
    });
  }

  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  
  const hexToRgb = (hex, opacity) => {
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  };

  const getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  };
  
  const getContrastYIQ = (hexcolor) => {
    hexcolor = hexcolor.replace('#', '');
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'darkf' : 'lightf';
  }

  function getCssVarHexWithoutHash(varName) {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(varName)
      .trim();

    if (!value) return null;

    // If already hex
    if (value.startsWith("#")) {
      return normalizeHex(value).replace("#", "");
    }

    // If rgb or rgba
    if (value.startsWith("rgb")) {
      const rgb = value.match(/\d+/g);
      if (!rgb) return null;

      const [r, g, b] = rgb.map(Number);

      return (
        toHex(r) +
        toHex(g) +
        toHex(b)
      );
    }

    return null;
  }

  function toHex(num) {
    return num.toString(16).padStart(2, "0");
  }

  function normalizeHex(hex) {
    if (hex.length === 4) {
      // #fff → #ffffff
      return (
        "#" +
        hex[1] + hex[1] +
        hex[2] + hex[2] +
        hex[3] + hex[3]
      );
    }
    return hex;
  }

  const createAreaTicketsObj = (layoutAreas, ticketTypes, rendelesAreaTickets) => {
    if (!rendelesAreaTickets || rendelesAreaTickets.length === 0) {
      setAreaTickets([]);
      setAreaIds([]);
      return;
    }

    let areaIds = [];
    setAreaTickets(rendelesAreaTickets.map(t => {
      let area = layoutAreas.find(x => x.tid === t.aid)
      let ticket = ticketTypes.find(x => x.tid === t.tid);
      areaIds.push(t.aid);

      return {
        hely: area.lab,
        jegy: ticket.nam,
        ar: ticket.pri,
        penznem: ticket.cur,
        mennyiseg: t.qua,
      };
    }));
    setAreaIds(areaIds);
  }

  const createSeatTicketsObj = (blockSeats, ticketTypes, rendelesSeatickets, sectors) => {
    if (!rendelesSeatickets || rendelesSeatickets.length === 0) {
      setSeatTickets([]);
      setSeatIds([]);
      return;
    }

    let seatIds = [];
    setSeatTickets(rendelesSeatickets.map(t => {
      let blockSeat = blockSeats.find(x => x.seat.tid === t.sid)
      let ticket = ticketTypes.find(x => x.tid === t.tid);
      let sector = sectors.find(x => x.id === blockSeat.seat.sec && !x.aid);
      seatIds.push(t.sid);

      return {
        hely: (sector.nam + ', ') + (blockSeat.block.lbp ? blockSeat.block.lbp : '') + ' ' + (blockSeat.block.lab || '') + ', ' + (blockSeat.block.lsp ? blockSeat.block.lsp : '') + ' ' + (blockSeat.seat.lab || '') + (blockSeat.block.lss ? blockSeat.block.lss : ' '),
        jegy: ticket.nam,
        ar: ticket.pri,
        penznem: ticket.cur,
      };
    }));
    setSeatIds(seatIds);
  }
  const renderReklam = () => {
    //document.documentElement.style.setProperty("--svg-viewer-hatter-szin", "rgb(31,20,58)");
    let className = "center-img " + (getCorrectTextColor(getCssVarHexWithoutHash("--svg-viewer-hatter-szin")) === "#ffffff" ? "feher-logo" : "fekete-logo")
    return !logoImageString ? null : (
        <img
          ref={logoRef}
          src={logoImageString}
          //src={logoImageString ? logoImageString : process.env.PUBLIC_URL + '/img/logo_kultik.png'}
          className={className}
          alt="logo"
        />
    );
  }

  const SORT_PATTERN = /\d+/g;

  const zeroPadding = (item) => item.replace(SORT_PATTERN, m => m.padStart(10, '0'));

  const buildKey = (item) => item.t + '|' + emptyFormatter(item.h) + '|' + emptyFormatter(item.j);

  const sortData = (data) => {
    if (!data) {
      return data;
    }

    return data.sort((a, b) => zeroPadding(buildKey(a)).localeCompare(zeroPadding(buildKey(b))));
  }

  const renderJegyvasarlas = () => {
    let data = [];
    let sum = 0;

    areaTickets.forEach(x => {
      for(let i = 0; i < x.mennyiseg; i++){
        data.push({
          t: 0, // állóhely típus
          h: x.hely,
          j: x.jegy,
          a: NumberFormatter.formatterSpaceOsszegPenznem(x.ar, null, x.penznem)
        });
        sum += x.ar;
      }
    });

    seatTickets.forEach(x => {
      data.push({
        t: 1, // ülőhely típus
        h: x.hely,
        j: x.jegy,
        a: NumberFormatter.formatterSpaceOsszegPenznem(x.ar, null, x.penznem)
      })
      sum += x.ar;
    });

    data = sortData(data).map((x, idx) => ({...x, s: (idx + 1) + '/' + data.length }));

    const columnsTickets = [
      {
        dataField: 's',
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'center',
          color: 'var(--base-font-szin)',
          fontWeight: '400',
          fontSize: '1.2rem',
          paddingTop: '4px',
          paddingBottom: '4px',
        },
        headerStyle: {
          backgroundColor: 'var(--elsodleges-szin)',
          fontSize: '1.6rem',
          color: 'white',
          width: '10%',
        },
      },
      {
        dataField: 'h',
        text: 'Hely',
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'left',
          color: 'var(--base-font-szin)',
          fontWeight: '400',
          fontSize: '1.2rem',
          paddingTop: '4px',
          paddingBottom: '4px',
        },
        headerStyle: {
          backgroundColor: 'var(--elsodleges-szin)',
          fontSize: '1.6rem',
          color: 'white',
        },
      },
      {
        dataField: 'j',
        text: 'Jegytípus',
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'left',
          color: 'var(--base-font-szin)',
          fontWeight: '400',
          fontSize: '1.2rem',
          paddingTop: '4px',
          paddingBottom: '4px',
        },
        headerStyle: {
          backgroundColor: 'var(--elsodleges-szin)',
          fontSize: '1.6rem',
          color: 'white',
        },
      },
      {
        dataField: 'a',
        text: 'Jegy ára',
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right',
          color: 'var(--base-font-szin)',
          fontWeight: '400',
          fontSize: '1.2rem',
          paddingTop: '4px',
          paddingBottom: '4px',
        },
        headerStyle: {
          backgroundColor: 'var(--elsodleges-szin)',
          fontSize: '1.6rem',
          color: 'white',
          textAlign: 'right',
          width: '20%',
        },
      },
    ];

    const rowStyle = (row, rowIndex) => {
      return { backgroundColor: 'transparent' };
    };

    const columnsSUM = [
      {
        dataField: 'o',
        style: {
          textAlign: 'center',
          color: 'var(--base-font-szin)',
          fontWeight: '500',
          fontSize: '2.5rem',
          border: 'none',
        },
        headerAttrs: { hidden: true,}
      },
      {
        dataField: 'j',
        style: {
          textAlign: 'center',
          color: 'var(--base-font-szin)',
          fontWeight: '500',
          fontSize: '2.5em',
          border: 'none',
        },
        headerAttrs: { hidden: true,}
      },
      {
        dataField: 's',
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right',
          color: 'var(--base-font-szin)',
          fontWeight: '500',
          fontSize: '2.5rem',
          border: 'none',
        },
        headerAttrs: { hidden: true,}
      }
    ];

    return (
      <div style={{color: 'var(--base-font-szin)', padding: 20, height: '100%'}}>
        <h1 style={{'textAlign': 'center'}}>{emptyFormatter(layout.vna)}</h1>
        <h2 style={{'textAlign': 'center'}}>{emptyFormatter(event.nam) + ' | ' +  (event.sta ? TimeFormatter.formatLLLL(event.sta) : '-') + ' | ' + emptyFormatter(layout.hna)}</h2>
        <div className="row">
          <div className="col-md-7">
            {/* {JSON.stringify(layout && layout.areas)} */}
            <SvgViewer
              fromAdmin
              twoColorMode
              isButtonsActive={false}
              height="90dvh"
              data={layout}
              szektorok={init.sectors}
              szinek={{
                coa: init.coa,
                con: init.con,
                cop: init.cop
              }}
              onSeatClick={() => {}}
              onAreaClick={() => {}}
              zoomEnabled={true}
              aktivRendelesAreaIds={areaIds}
              aktivRendelesSeatIds={seatIds}
            />
          </div>
          <div className="col-md-5">
            <div className="col-md-12"
              style={{
                borderRadius: '12px',
                borderTop: '4px solid var(--elsodleges-szin)',
                maxHeight: '83dvh',
                overflow: 'hidden',
              }}
            >
              { !data.length ? <div style={{ height: '90dvh' }} /> :
                <React.Fragment>
                  <div style={{ paddingTop: '20px', }}>
                    <BootstrapTable
                      bootstrap4
                      keyField="n"
                      data={data}
                      columns={columnsTickets}
                      rowStyle={rowStyle}
                      bordered={false}
                    />
                  </div>
                  <div className="col-md-12" style={{ display: 'flex'}}>
                    <BootstrapTable
                      bootstrap4
                      keyField="o"
                      data={[{o: 'Összesen:', j: data.length + ' db', s: NumberFormatter.formatterSpaceOsszegPenznem(sum, null, emptyFormatter(event.cur))}]}
                      columns={columnsSUM}
                      rowStyle={rowStyle}
                      bordered={false}
                      />
                  </div>
                </React.Fragment>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

    return (
      <div>
        {!error ? (
        <div className="animated fadeIn" style={{ height: '100%' }}>
            {{
              REKLAM: (renderReklam()),
              FOGLALAS: (renderJegyvasarlas()),
              LEKERDEZES: (renderJegyvasarlas()),
            }[clientType]
            }
        </div>
        ):(
        <Page404/>
        )}
      </div>
    );
}

export default KulsokliensContent; 